export const getPurchasedProductSkus = () =>
	window?.dataLayer?.[0]?.order?.skuID;
